module.exports = __webpack_public_path__ + "img/_icon-sign-in.759205fa.svg";